var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"height-crossfade"},[_c('transition',{attrs:{"name":"height-crossfade"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }